const $ = require('jquery');
import _ from "underscore";
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import run from '../../utilities/run';
import {validateOnAllSelectChanges} from "../../utilities/select2able";
import render from "../../utilities/render";
import {setElementsFromScope} from "../../utilities/selectorHelpers";
import {createPreventDefault} from '../../utilities/general';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
import collectDataAttributesFor from "../../utilities/collectDataAttributesFor";
import pagination from "../../components/pagination/pagination";
import {isPresent} from "../../utilities/general";

const tableStatusPill = require('./html/rulesStatusPill.html');
const tableActionBtns = require('./html/rulesActionBtns.html');
const tableRuleLink = require('./html/ruleLink.html');
const sharedModalHtml = require("../../sharedHtml/modal.html");
const targetSelector = "#returns-rules-lookup-id";

run(targetSelector, ()=>{
  const el = $("#returns-rules-lookup-id");
  returnsRulesLookup(el);
});

function returnsRulesLookup(el) {
  let deactivateModalEl, activateModalEl, returnRulesDataTable;
  const createUpdateURL  = el.data("create-update-url");
  const detailURL  = el.data("detail-url");
  const elTable = el.find(".return-rules-table");
  const elTableBody = el.find(".return-rules-engine-tbody");
  const rules = el.data("rules");
  let currentReturnRuleRow;
  const activeRuleURL = el.data("activate-rule-url");
  const inActiveRuleURL = el.data("inactivate-rule-url");
	
	
	const activateRuleModal = new SubmitModalFlow({
	confirmModalTitle: 'Activate Rule',
	confirmModalBody: `<div class="q-pad-all-xl">
							Once updated, these changes will be reflected throughout the application.
						  </div>`,
	confirmModalBtnText: 'Activate Rule',
	onConfirmClick: function(){
		activateRuleModal.showLoadingModal();
		activateInactiveAjax({url: activeRuleURL, success:activeRuleSuccess, error: activeRuleError});
	}
  });
  activateRuleModal.init();

  const deactiveRuleModal = new SubmitModalFlow({
		confirmModalTitle: 'Deactive Rule',
		confirmModalBody: `<div class="q-pad-all-xl">
							Once updated, these changes will be reflected throughout the application.
						  </div>`,
		confirmModalBtnText: 'Deactive Rule',
		onConfirmClick: function(){
		  deactiveRuleModal.showLoadingModal();
		  activateInactiveAjax({url: inActiveRuleURL, success:inActiveRuleSuccess, error: inActiveRuleError});
		}
	});
  deactiveRuleModal.init();
  
  
  function activateInactiveAjax({url, success, error}) {
	$.ajax({
		data:{returnRuleId: currentReturnRuleRow.data().returnRuleId} ,
		url: url,
		dataType:"TEXT",
		type: 'POST',
		success: success,
		error: error
	});
  }
  
  
  function activeRuleSuccess(returnRuleId){
	  if(returnRuleId > 0){
		EditChecker.setPageClean();
		activateRuleModal.showSuccessModal();
		let updateRow = currentReturnRuleRow.data();
		updateRow.returnRuleId=currentReturnRuleRow.data().returnRuleId;
		updateRow.returnRule=currentReturnRuleRow.data().returnRule;
		updateRow.returnDesc=currentReturnRuleRow.data().returnDesc;
		updateRow.returnEffectiveUntil=currentReturnRuleRow.data().returnEffectiveUntil;
		updateRow.returnStatus=true;
		currentReturnRuleRow.data(updateRow).draw();
		setTimeout(function() {
		 activateRuleModal.hideAllModals();
		}, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	  }else{
		activateRuleModal.showFailureModal();
	  }
  }

  function activeRuleError(){
	 activateRuleModal.hideAllModals();
  }

  
  function inActiveRuleSuccess(returnRuleId){
	  if(returnRuleId > 0){
		EditChecker.setPageClean();
		deactiveRuleModal.showSuccessModal();
		let updateRow = currentReturnRuleRow.data();
		updateRow.returnRuleId=currentReturnRuleRow.data().returnRuleId;
		updateRow.returnRule=currentReturnRuleRow.data().returnRule;
		updateRow.returnDesc=currentReturnRuleRow.data().returnDesc;
		updateRow.returnEffectiveUntil=currentReturnRuleRow.data().returnEffectiveUntil;
		updateRow.returnStatus=false;
		currentReturnRuleRow.data(updateRow).draw();
		setTimeout(function() {
		 deactiveRuleModal.hideAllModals();
		}, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	  }else{
		deactiveRuleModal.showFailureModal();
	  }
  }

  function inActiveRuleError(){
	 deactiveRuleModal.hideAllModals();
  }

 
  const defaultLookupDataTableOptions = {
    "searching": false,
    "paging": false,
    "ordering": false,
    "info": false,
	"columnDefs": [
      { "targets": [1], "orderable": false },
      { className: "q-text-center", "targets": [ 4 ], "orderable": false }
      ]
  };

  const returnsRulesLookupEl = elTable.dataTable({
	   ...defaultLookupDataTableOptions,
	  data: rules.content,
		columns: [
			{
				data: "returnRule",
				"class": "anchor-text",
				render: renderReturnsRulesDetailLink
			 },
			{
				data: "returnDesc"
			},
			{
				data: "returnEffectiveUntil"
			},
			{
				data: "returnStatus",
				render: renderStatusPill
				
			},
			{
				data: "returnStatus",
				render: renderRowActionBtns
			}
		]
    });
 
  function renderReturnsRulesDetailLink(data, type, row) {
    return `<a href=${detailURL}&returnRuleId=${row.returnRuleId}> ${data} </a>`;
  }

  function renderStatusPill(data, type, row){
    return render(
      tableStatusPill,
      {
        value: getStatusPillText(data),
        pillClassName: getStatusPillColor(data)
      }
    );
  }
 
  function getStatusPillColor(status){
    return isStatusActive(status) ? "q-pill-blue" : "q-pill-white-and-blue";
  }

  function getStatusPillText(status){
    return isStatusActive(status) ? "Active" : "Inactive";
  }

  function getToggleIconClass(status){
    return isStatusActive(status) ? "deactivate-rule-btn fa-toggle-on" : "activate-rule-btn fa-toggle-off";
  }

  function isStatusActive(status){
    return !!status;
  }

  function getTableData(){
    return returnRules.data;
  }
  
  function renderRowActionBtns(data, type, row){
   return render(
     tableActionBtns,
      {
        toggleStatusIconClassName: getToggleIconClass(data)
      }
    );
  }
  // These const should define after dataTable is render otherwise it will be assigned  "Undefined"
  const activeRuleBtn = $(".activate-rule-btn");
  const deactiveRuleBtn = $(".deactivate-rule-btn");
  const returnRuleEditBtn = $(".return-rule-edit-btn");
 
	activeRuleBtn.on('click',function(e) {
		e.preventDefault();
		currentReturnRuleRow = elTable.api().row( $(this).closest('tr'));
    activateRuleModal.showConfirmModal();
	});
	
	deactiveRuleBtn.on('click',function(e) {
		e.preventDefault();
		currentReturnRuleRow = elTable.api().row( $(this).closest('tr'));
		deactiveRuleModal.showConfirmModal();
	});
	
	returnRuleEditBtn.on('click',function(e) {
		e.preventDefault();
		let row = elTable.api().row( $(this).closest('tr'));
		location.href = `${createUpdateURL}&returnRuleId=${row.data().returnRuleId}`;

	});

	/* pagination at frontend  START */
  const filterURL = el.data("filter-returns-rules-url");
	window.migrateLookupFrontend = true;
	const els = {};
  const noop = (()=>{});
  const namespace = el.data("namespace");
  const elementsMap = {
    emptyDiv: `.${namespace}return-rules-table .dataTables_empty`,
    table: ".return-rules-table",
    sortFieldHiddenInput: `#${namespace}sortField`,
    sortTypeHiddenInput: `#${namespace}sortType`,
    form: `#${namespace}filter-form`,
    itemsPerPageSelect: `#${namespace}itemsPerPage`,
    searchCriteria: `#${namespace}searchCriteria`
  };
  setElements();
  function setElements() {
    setElementsFromScope(els, elementsMap, el);
    els.lookupOuter = el;
    els.rules = rules;
    els.namespace = namespace;
    els.generalErrorMessage = el.data("general-error-message");
    els.lang = collectDataAttributesFor(els.lookupOuter.get(0), {prefix: "lang", camelize: false});
  }
  els.sortFieldHiddenInput.val("cbrCreatedDate");
  els.sortTypeHiddenInput.val("asc");
  els.itemsPerPageSelect.val(els.rules.page.size);
 
  const paginator = pagination(els.lookupOuter, {
    tableData: els.rules,
    lang: els.lang
  });
  
	
	
  function postLookupSearchHelper({pageNumber=0}={}) {
		
    postLookupSearch({pageNumber: pageNumber, elements: els, success: receivePostLookupSearch});
  }
 
	let searchRequest;

  function postLookupSearch(options={}) {
	  const {elements, pageNumber, size, orderBy, orderByType, url, success=noop, error=noop} = options;
    // Show loading overlay
    if(searchRequest){
      // console.log("aborting");
      searchRequest.abort();
    }

    searchRequest = $.ajax({
      url: filterURL,
      type: 'POST',
      data: getCurrentPageDataForSearch(options),
      dataType: 'JSON',
      // DONT DO THIS
      // async: false,
      success: function(data) {
        // hide loading overlay
        searchRequest = null;
        success(data);
      },
      error: error
    });
  }

  function receivePostLookupSearch(newData){
    returnsRulesLookupEl.fnClearTable();
    els.rules = newData;
    if (els.rules.content.length > 0) {
      returnsRulesLookupEl.fnAddData(els.rules.content);
    } else {
     els.emptyDiv.text(els.lang['lookup-filter-no-results-found']);
    }
    paginator.setTableData(els.rules);
  }
	
  function getCurrentPageDataForSearch({elements=els, pageNumber, size, orderBy, orderByType}){
		const dataStr = elements.form.serialize();
    const additionalDataStr = $.param({
      [`${namespace}page`]: (isPresent(pageNumber) ? pageNumber : 0),
      [`${namespace}size`]: (isPresent(size) ? size : elements.itemsPerPageSelect.val()),
      [`${namespace}orderBy`]: (isPresent(orderBy) ? orderBy : elements.sortFieldHiddenInput.val()),
      [`${namespace}orderByType`]: orderByType || elements.sortTypeHiddenInput.val()
    });

    return dataStr + "&" + additionalDataStr;
  }
	
	// This event notably comes from the backend js file,
  // this is a work-around for now to allow the abundance of
  // triggerSearch calls to be ported to the front
  els.lookupOuter.on('exec-search', handleExecSearchEvent);

  function handleExecSearchEvent(e, pageNumber){
    postLookupSearchHelper({pageNumber});
  }
	
	/* pagination at frontend  END */

	

}



// WEBPACK FOOTER //
// ./src/pages/returnsRules/lookup.js